import { createContext, useContext } from 'react'

export const AuthenticationContext = createContext()

export function useAuthentication() {
  const context = useContext(AuthenticationContext)

  if (!context) {
    throw new Error(
      'useAuth debe ser usado dentro de un component envuelto con AuthenticationContext',
    )
  }
  return context
}

export function useLogout() {
  const { setIsAuth } = useAuthentication()
  localStorage.removeItem('__atk__')
  setIsAuth(false)
}